import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getClientsReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pnl-report/clients', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.client,
    params: data
  })
}
